<template>
  <div class="premium-message">
    <div class="prev" @click="goToGoodList">
      <i class="bi bi-chevron-left"></i>
    </div>
    <img src="/images/premium_message/message-detail.png" alt="" class="image" />
    <div class="received-message-count">
      {{ userName }}さん宛に<br />
      {{ messageCount }}通メッセージが届きました
    </div>
    <img src="/images/premium_message/decoration.png" alt="" class="image" />
    <div class="note">
      メッセージをくれた方へ「ありがとう」を返してみましょう。<br />
      メッセージは3週間放置すると、リセットされます。
    </div>
    <PremiumMessageDetail
      v-for="(message, i) in messages"
      :message="message"
      :key="i"
      @skip="handleSkip"
      @thanks="handleThanks"
    />
  </div>
</template>

<script>
import PremiumMessageDetail from '../components/PremiumMessageDetail.vue';

export default {
  name: 'PremiumMessage',
  components: {
    PremiumMessageDetail,
  },
  data() {
    return {
      messages: [],
      totalCount: 0,
      unReadCount: 0,
      userName: '',
    }
  },
  computed: {
    messageCount() {
      return this.messages.length;
    }
  },
  async mounted() {
    try {
      await this.fetchPremiumMessages()
    } catch (error) {
      console.error('Failed to fetch premium messages', error)
    }

    try {
      await this.fetchUserName()
    } catch (error) {
      console.error('Failed to fetch user name', error)
    }
  },
  methods: {
    async fetchPremiumMessages() {
      const response = await axios.get('/api/matching/premium-message-like/list');
      this.messages = response.data.premium_message_likes;
      this.totalCount = response.data.total_count;
      this.unReadCount = response.data.unread_count;
    },
    async handleSkip(message) {
      const userId = message && message.user ? message.user.id : undefined;
      if (!userId) {
        return;
      }

      const confirmed = confirm('スキップします。よろしいですか？');
      if (!confirmed) {
        return;
      }

      try {
        await axios.get(`/api/matching/penalty/skip/${userId}/1/0`);

        if (this.$router && this.$router.currentRoute) {
          this.$router.go({ path: this.$router.currentRoute.path, force: true });
        } else {
          await this.fetchPremiumMessages();
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          window.location.href = '/auth?logout=true';
        } else if (typeof this.$showErrorToast === 'function') {
          this.$showErrorToast('通報に失敗しました');
        } else {
          console.error('Failed to skip premium message', error);
        }
      }
    },
    async handleThanks(message) {
      const userId = message && message.user ? message.user.id : undefined;
      if (!userId) {
        return;
      }

      try {
        const response = await axios.post('/api/matching/congratulation/set', {
          user_id_to: userId,
          message: '',
        });

        const matchingId = response.data && response.data.matchings ? response.data.matchings.id : undefined;
        const redirectUrl = matchingId
          ? `/matching/congratulation/${userId}?mid=${matchingId}`
          : `/matching/congratulation/${userId}`;
        window.location.href = redirectUrl;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          window.location.href = '/auth?logout=true';
        } else if (typeof this.$showErrorToast === 'function') {
          this.$showErrorToast('マッチングに失敗しました');
        } else {
          console.error('Failed to send thanks', error);
        }
      }
    },
    async fetchUserName() {
      const response = await axios.get('/api/user/get/me');
      const user = response.data && response.data.user ? response.data.user : {};
      this.userName = user && user.name ? user.name : '';
    },
    goToGoodList() {
      if (this.$router) {
        try {
          this.$router.push({ name: 'MatchingGoodList' })
        } catch (e) {
          this.$router.push('/good/list')
        }
      } else {
        window.location.href = '/good/list'
      }
    }
  }
};
</script>

<style scoped>
.premium-message {
  min-height: 100vh;
  margin: 0 -12px;
  padding-bottom: 24px;
  background: #4f3f81;
}

.prev {
  padding: 8px 12px;
}

.prev .bi-chevron-left {
  color: white;
  font-size: 28px;
  -webkit-text-stroke: 3px;
  cursor: pointer;
}

.image {
  width: 100%;
}

.received-message-count {
  padding: 12px 0;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
}

.note {
  margin-top: 8px;
  padding: 8px 16px;
  font-size: 11px;
  color: #fff;
  line-height: 1.5;
}

.old-message-heading {
  padding: 8px 16px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}

</style>
